import { TranslationService } from '../services/translation.service'

const translationService = new TranslationService()

export const ROUTES = {
  VITE_MARKETPLACE: {
    title: translationService.getBrandNameText(),
    path: '',
  },
  HOME: {
    title: translationService.getHomeText(),
    path: '/',
  },
  MARKETPLACE: {
    title: translationService.getMarketplaceBrowseText(),
    path: 'marketplace',
  },
  REQUISITION_CART: {
    title: translationService.getRequisitionCartText(),
    path: 'requisition-cart',
  },
  PURCHASE_ORDERS: {
    title: translationService.getPurchaseOrdersText(),
    path: 'purchase-orders',
  },
  REQUISITIONS: {
    title: translationService.getRequisitionSavedText(),
    path: 'requisitions',
  },
  ADVANCED_SEARCH: {
    title: translationService.getProductsText(),
    path: 'products',
  },
  COMPANY_PRODUCTS: {
    title: translationService.getCompanyProductsText(),
    path: 'products',
  },
  COMPANY: {
    title: translationService.getCompaniesText(),
    path: 'companies',
  },
  CREATE_COMPANY: {
    title: translationService.getCreateCompanyText(),
    path: 'create',
  },
  LOGIN: {
    title: translationService.getLoginText(),
    path: 'login',
  },
  PRODUCT: {
    title: translationService.getProductText(),
    path: 'products/:id',
  },
  PRODUCT_OVERVIEW: {
    title: translationService.getOverviewText(),
    // NOTE - this is a child route. Full route is 'product/:id/overview'
    path: 'overview',
  },
  PRODUCT_SUPPLY_CHAIN: {
    title: translationService.getSupplyChainText(),
    // NOTE - this is a child route. Full route is 'product/:id/supply-chain'
    path: 'supply-chain',
  },
  PRODUCT_SUSTAINABILITY: {
    title: translationService.getSustainabilityText(),
    // NOTE - this is a child route. Full route is 'product/:id/sustainability'
    path: 'sustainability',
  },
  PRODUCT_COMPONENTS: {
    title: translationService.getComponentsText(),
    // NOTE - this is a child route. Full route is 'product/:id/components'
    path: 'components',
  },
  PRODUCT_SCORES: {
    title: translationService.getScoresText(),
    // NOTE - this is a child route. Full route is 'product/:id/scores'
    path: 'scores',
  },
  PRODUCT_REGULATIONS: {
    title: translationService.getRegulationsText(),
    // NOTE - this is a child route. Full route is 'product/:id/regulations'
    path: 'regulator-info',
  },
  ADMIN: {
    title: translationService.getAdminText(),
    path: 'admin',
  },
  USERS: {
    title: translationService.getUsersText(),
    // NOTE - this is a child route. Full route is 'admin/users'
    path: 'users',
  },
  USERS_CREATE: {
    title: translationService.getCreateUserText(),
    path: 'users/create',
  },
  SET_PASSWORD: {
    title: translationService.getSetPasswordText(),
    path: 'set-password/:passwordToken',
  },
  AUTH: {
    title: translationService.getAuthText(),
    path: 'auth',
  },
  PRODUCT_ADD: {
    title: translationService.getProductAddText(),
    path: 'product-add',
  },
  RESET_PASSWORD: {
    title: translationService.getResetPasswordText(),
    path: 'reset-password',
  },
  INTEGRATIONS: {
    title: translationService.getIntegrationsText(),
    path: 'integrations',
  },
  SUBSTANCES: {
    title: translationService.getSubstancesText(),
    path: 'substances',
  },
  LIABILITY_DISCLAIMER: {
    title: translationService.getLiabilityDisclaimerText(),
    path: 'liability-disclaimer',
  },
  PRODUCT_INGREDIENTS: {
    // NOTE - this is a child route. Full route is 'product/:id/ingredients'
    title: translationService.getIngredientsText(),
    path: 'ingredients',
  },
  INGREDIENTS: {
    title: translationService.getIngredientsText(),
    path: 'ingredients',
  },
  INGREDIENTS_CREATE: {
    title: translationService.getCreateIngredientText(),
    path: 'ingredients/create',
  },
  INGREDIENTS_EDIT: {
    title: translationService.getEditIngredientText(),
    path: 'ingredients/:id/edit',
  },
  SETTINGS: {
    title: translationService.getSettingsText(),
    path: 'settings',
  },
  LANGUAGE: {
    title: translationService.getLanguageText(),
    path: 'settings/language',
  },
  PRODUCT_CSV_TEMPLATES: {
    title: translationService.getProductCSVTemplatesText(),
    path: 'settings/product-csv-templates',
  },
  PRODUCT_CSV_TEMPLATES_EDIT: {
    title: translationService.getProductCSVTemplatesText(),
    path: 'settings/product-csv-templates/:id/edit',
  },
  IMPORT_PRODUCTS: {
    title: translationService.getImportProductsText(),
    path: 'import-products',
  },
  INGREDIENT_CSV_TEMPLATES: {
    title: translationService.getIngredientCSVTemplatesText(),
    path: 'settings/ingredient-csv-templates',
  },
  INGREDIENT_CSV_TEMPLATES_EDIT: {
    title: translationService.getIngredientCSVTemplatesText(),
    path: 'settings/ingredient-csv-templates/:id/edit',
  },
  IMPORT_INGREDIENTS: {
    title: translationService.getImportIngredientsText(),
    path: 'ingredients/import',
  },
  PRODUCT_PLASTICS_DECLARATION: {
    // NOTE - this is a child route. Full route is 'product/:id/plastics-declaration'
    title: 'FPR',
    path: 'plastics-declaration',
  },
  REPORTS: {
    title: translationService.getReportsText(),
    // NOTE - this is a child route. Full route is 'admin/reports'
    path: 'reports',
  },
  ADD_TO_CATALOGUE: {
    title: translationService.getAddToCatalogueText(),
    path: 'add-to-catalogue',
  },
  ADD_FPR_REPORT: {
    title: translationService.getCreateFprReportText(),
    path: 'reports/fpr',
  },
  FPR_REPORT_EDIT: {
    title: translationService.getCreateFprReportText(),
    path: 'reports/fpr/:id/edit',
  },
  FPR_TEMPLATES: {
    title: translationService.getFprTemplatesText(),
    path: 'settings/fpr-templates',
  },
  FPR_TEMPLATE_EDIT: {
    title: translationService.getFprTemplatesText(),
    path: 'settings/fpr-templates/:id/edit',
  },
  PRODUCT_SHARING_CSV_TEMPLATES: {
    title: translationService.getProductSharingCSVTemplatesText(),
    path: 'settings/product-sharing-csv-templates',
  },
  PRODUCT_SHARING_CSV_TEMPLATES_EDIT: {
    title: translationService.getProductSharingCSVTemplatesText(),
    path: 'settings/product-sharing-csv-templates/:id/edit',
  },
  IMPORT_PRODUCT_SHARING: {
    title: translationService.getBulkProductSharingText(),
    path: 'import-product-sharing',
  },
}
